import React from 'react';
import { CatalogItemType } from '@common/model/catalog/item/type';
import {
  CatalogBannerSearchProps as CatalogBannerSearchEntityProps,
  CatalogBannerSearch as CatalogBannerSearchForVacancyEntity,
} from 'src/entities/catalog/banner';
import { useRegistrationForSpecialist } from 'src/features/client/current/registration/specialist';

export type CatalogBannerSearchForVacancyProps = Omit<CatalogBannerSearchEntityProps, 'onClick' | 'itemType'>;

export const CatalogBannerSearchForVacancy: React.FC<CatalogBannerSearchForVacancyProps> = (props) => {
  const startRegistrationForSpecialist = useRegistrationForSpecialist();

  return <CatalogBannerSearchForVacancyEntity itemType={CatalogItemType.Vacancy} {...props} onClick={startRegistrationForSpecialist} />;
};
